// HTML5 type="email" akzeptiert Adressen mit einlabeliger Domain ("name@gmx").
// Der Mailserver lehnt die spaeter mit "501 5.1.6 Recipient addresses in single
// label domains not accepted" ab - dann scheitert der Mailversand im Hintergrund,
// obwohl der Kunde den Antrag laengst abgeschickt hat. Deshalb schon im Formular
// einen Punkt in der Domain verlangen.
// Gegenstueck im Backend: Antrag::EMAIL_ZUSTELLBAR
export const EMAIL_PATTERN = "[^@\\s]+@[^@\\s.]+(\\.[^@\\s.]+)+";

export const EMAIL_TITLE =
  "Bitte eine vollständige E-Mail-Adresse angeben, z. B. name@beispiel.de";
